import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=a1bd09b0&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=ts"
export * from "./bulk.vue?vue&type=script&lang=ts"
import style0 from "./bulk.vue?vue&type=style&index=0&id=a1bd09b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bd09b0",
  null
  
)

export default component.exports